export const CONTEXTUAL_INVITE_NUDGE = {
	EXPERIMENT_ELIGIBLE_TAG: 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag',
	WAS_CONFETTI_SEEN: 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen',
} as const;

export const ContextualInviteNudgeOnboardingKeys: readonly (
	| 'onboarding-contextual-invite-nudge:contextualInviteNudgeEligibleTag'
	| 'onboarding-contextual-invite-nudge:wasFirstPublishConfettiSeen'
)[] = Object.values(CONTEXTUAL_INVITE_NUDGE);
